import Popover from './src/Popover'
import { reactToCwp } from '../../../common/react-utils.jsx'

export default reactToCwp(Popover)
